import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const modalRoot = document.querySelector('#root');

export const Portal = ({ children }) => {
  const reference = useRef(null);
  if (!reference.current) reference.current = document.createElement('div');

  useEffect(() => {
    const currentRef = reference.current;
    modalRoot.appendChild(currentRef);
    return () => {
      modalRoot.removeChild(currentRef);
    };
  }, []);

  return createPortal(children, reference.current);
};
